"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatevInformationEnum = exports.DatevBookingTextEnum = exports.DatevReimbursementWithItems = exports.DatevReimbursementWithoutItems = exports.DatevSubscription = exports.DatevOteWithItems = exports.DatevOteWithoutItems = void 0;
var DatevOteWithoutItems;
(function (DatevOteWithoutItems) {
    DatevOteWithoutItems["DESCRIPTION"] = "description";
    DatevOteWithoutItems["INVOICE_NUMBER"] = "invoiceNumber";
    DatevOteWithoutItems["VENDOR"] = "vendor";
    DatevOteWithoutItems["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
})(DatevOteWithoutItems || (exports.DatevOteWithoutItems = DatevOteWithoutItems = {}));
var DatevOteWithItems;
(function (DatevOteWithItems) {
    DatevOteWithItems["ITEMS"] = "items";
    DatevOteWithItems["DESCRIPTION"] = "description";
    DatevOteWithItems["INVOICE_NUMBER"] = "invoiceNumber";
    DatevOteWithItems["VENDOR"] = "vendor";
    DatevOteWithItems["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
})(DatevOteWithItems || (exports.DatevOteWithItems = DatevOteWithItems = {}));
var DatevSubscription;
(function (DatevSubscription) {
    DatevSubscription["EXPENSE_TYPE"] = "expenseType";
    DatevSubscription["SUBSCRIPTION_NAME"] = "subscriptionName";
    DatevSubscription["DESCRIPTION"] = "description";
    DatevSubscription["INVOICE_NUMBER"] = "invoiceNumber";
    DatevSubscription["VENDOR"] = "vendor";
    DatevSubscription["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
})(DatevSubscription || (exports.DatevSubscription = DatevSubscription = {}));
var DatevReimbursementWithoutItems;
(function (DatevReimbursementWithoutItems) {
    DatevReimbursementWithoutItems["REIMBURSEMENT_TYPE"] = "reimbursementType";
    DatevReimbursementWithoutItems["EMPLOYEE_NAME"] = "employeeName";
    DatevReimbursementWithoutItems["DESCRIPTION"] = "description";
    DatevReimbursementWithoutItems["INVOICE_NUMBER"] = "invoiceNumber";
    DatevReimbursementWithoutItems["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
})(DatevReimbursementWithoutItems || (exports.DatevReimbursementWithoutItems = DatevReimbursementWithoutItems = {}));
var DatevReimbursementWithItems;
(function (DatevReimbursementWithItems) {
    DatevReimbursementWithItems["REIMBURSEMENT_TYPE"] = "reimbursementType";
    DatevReimbursementWithItems["EMPLOYEE_NAME"] = "employeeName";
    DatevReimbursementWithItems["DESCRIPTION"] = "description";
    DatevReimbursementWithItems["INVOICE_NUMBER"] = "invoiceNumber";
    DatevReimbursementWithItems["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
    DatevReimbursementWithItems["ITEMS"] = "items";
})(DatevReimbursementWithItems || (exports.DatevReimbursementWithItems = DatevReimbursementWithItems = {}));
var DatevBookingTextEnum;
(function (DatevBookingTextEnum) {
    DatevBookingTextEnum["DESCRIPTION"] = "description";
    DatevBookingTextEnum["VENDOR"] = "vendor";
    DatevBookingTextEnum["DISCOUNT"] = "discount";
})(DatevBookingTextEnum || (exports.DatevBookingTextEnum = DatevBookingTextEnum = {}));
var DatevInformationEnum;
(function (DatevInformationEnum) {
    DatevInformationEnum["REIMBURSEMENT_TYPE"] = "reimbursementType";
    DatevInformationEnum["EXPENSE_TYPE"] = "expenseType";
    DatevInformationEnum["SUBSCRIPTION_NAME"] = "subscriptionName";
    DatevInformationEnum["VENDOR"] = "vendor";
    DatevInformationEnum["EMPLOYEE_NAME"] = "employeeName";
    DatevInformationEnum["DESCRIPTION"] = "description";
    DatevInformationEnum["INVOICE_NUMBER"] = "invoiceNumber";
    DatevInformationEnum["FINWAY_EXPENSE_NUMBER"] = "finwayExpenseNumber";
    DatevInformationEnum["ITEMS"] = "items";
    DatevInformationEnum["DISCOUNT"] = "discount";
    DatevInformationEnum["NOT_SET"] = "notSet";
})(DatevInformationEnum || (exports.DatevInformationEnum = DatevInformationEnum = {}));
